import React, { Component } from 'react';
import { Link } from 'react-router';
import { isEmpty } from 'ramda';

import s from './Notifications.css';


/**
* Wraps Notifications and passes renderNotifications()
*/
const withNotificationBuilder = () => {

  return (WrappedComponent) => {

    class withNotificationBuilder extends Component {

      // childParams are an empty object until the request completes
      renderNotifications = (childParams) => {

        const emptyPlaceholder = (
          <p className={s.message}>
            You have no new notifications.
          </p>
        );

        return !isEmpty(childParams) ? this.getNotifications(childParams) : emptyPlaceholder;

      };

      getNotifications = (params) => {

        const notifications = params.map((item, key) => {
          const route = item.route;
          const body = item.body;
          const title = item.title;

          return (
            <li key={key} className={s.notification}>
              <Link
                to={`/${route}`}
                title={`New ${title}`}
                className={s.action}
              >
                <div className={s.truncate}>
                  <strong>{title}</strong> <span>{body}</span>
                </div>
                <div className={s.details}>
                  <span className={s.subheading}>View Details</span>
                  <div className={s.caret} />
                </div>
              </Link>
            </li>
          );

        });

        return (
          <ul className={s.list}>
            {notifications}
          </ul>
        );

      };

      render = () => {

        return (
          <WrappedComponent
            {...this.props}
            renderNotifications={this.renderNotifications}
          />
        );

      };

    }

    return withNotificationBuilder;

  };

};

export default withNotificationBuilder;



// WEBPACK FOOTER //
// ./src/components/Notifications/withNotificationBuilder.js